module.exports = __webpack_public_path__ + "img/intro text_no.0868ede8.svg";